import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/ec/Customer-Analytics.webp";
import Img02 from "../../images/services/ec/Online-Shopping.webp";
import Img03 from "../../images/services/ec/Order-Management.webp";
import Img04 from "../../images/services/ec/Payment-Gateways.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Partner">
                            <h2>Partner With TekRevol</h2>
                        </div>
                        <p>We are a versatile team of creatives, business opportunists,
                            designers, developers, and product strategists who love penetrating the newest routes to
                            market. Partner with us if you want to reshape your customer relationships and work on an
                            operating model that guarantees high turnover and levels up your brand.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Customer Analytics</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Order Management</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Online Shopping</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Payment Gateways</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    )
        ;
}

export default Servicespartner;